import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React from 'react';

/**
 * BenefitBoxProps
 */
export interface BenefitBoxProps {
  elements: BenefitsItem[];
}

/**
 * BenefitsItem
 */
export interface BenefitsItem {
  icon?: string;
  header: string;
  text?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ListItemText: {
      color: 'white'
    },
    MuiListItem: {
      alignItems: 'flex-start'
    },
    MuiListItemText: {
      margin: 0
    }
  })
);

const BenefitBox = ({ elements }: BenefitBoxProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Box borderRadius={5} component="div" bgcolor={CORPORATE_COLORS.RX} p={2.5}>
      <List disablePadding={true}>
        {elements.map(({ header, text }, id) => (
          <ListItem className={classes.MuiListItem} key={id} disableGutters={true}>
            <ListItemIcon>
              <Box fontWeight="fontWeightBold" color="white">
                <CheckIcon />
              </Box>
            </ListItemIcon>
            <ListItemText className={classes.MuiListItemText}>
              <Typography
                variant="subtitle1"
                className={classes.ListItemText}
                dangerouslySetInnerHTML={{ __html: header }}
              />
              <Typography
                variant="body1"
                className={classes.ListItemText}
                dangerouslySetInnerHTML={{ __html: text ?? '' }}
              />
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export { BenefitBox };
